// extracted by mini-css-extract-plugin
export default {"tableContainer":"AdImportDrawerTable_tableContainer__M+4lr"};